import NotificationBell from './components/NotificationBell'

export default NotificationBell
